module.exports = __webpack_public_path__ + "img/Brand_mob_atlassian.ff9829ce.svg";